import { http, httpFile } from './http_service';

// Get all settled quote during from date & to date for Admin or Staff
export function getAllSettledReport(data){
    return http().put('/reports/get-all-settled-report', data);
}
// Get all settled quote during from date & to date for Dealer manger
export function dealerManagerGetAllSettled(dealerManagerId, data){
    return http().put(`/reports/dealer-manager-get-all-settled-report/${dealerManagerId}`, data);
}
// Get all settled quote during from date & to date for Dealer
export function dealerGetAllSettled(dealerUserId, data){
    return http().put(`/reports/dealer-get-all-settled-report/${dealerUserId}`, data);
}
// Get all settled leads quotes during from date & to date for Referral Partners
export function referralPartnerGetAllSettled(referralPartnerId, data){
    return http().put(`/reports/referral-partner-get-all-settled-report/${referralPartnerId}`, data);
}

 /**
 * VsaSettlement Export
 * First create file in temp folder
 * Then download and delete temp file
 * during from date & to date for Admin or Staff
 */
export function createVsaSettlementExport(data){
    return http().post('/reports/export/create-vsa-settlement', data);
}
/**
 * Delete temp file
 * @param {*} data 
 * @returns 
 */
export function deleteTempVsaSettlementExport(data){
    return http().put('/reports/export/delete-temp-vsa-settlement', data);
}






